module.exports = __webpack_public_path__ + "static/media/6_pricol.3c7529fb.svg";